import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f69f1e08"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f69f1e08')) {
      api.createRecord('f69f1e08', component.options)
    } else {
      api.reload('f69f1e08', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f69f1e08", function () {
      api.rerender('f69f1e08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DMCopyNotification/index.vue"
export default component.exports